/**
 * A data object used by a Task to notify the Progress Modal that progress has occurred.
 */
export default class TaskStatus {

  /**
   * Constructor
   */
  constructor(id, taskName, progressDialog) {
    
    // Capture the parameters.
    this._id = id;
    this._taskName = taskName;
    this._progressDialog = progressDialog;
    
    // Set any default values.
    this._progress = 0;

  }

  /**
   * Accessor method for the {@link #_id} property.
   */
  get id() { return this._id; }

  /**
   * Accessor method for the {@link #_taskName} property.
   */
  get taskName() { return this._taskName; }

  /**
   * Accessor method for the {@link #_progress} property.
   */
  get progress() { return this._progress; }

  /**
   * Setter method for the {@link #_progress} property. Invoking this method causes the
   * {@link #_progressDialog} to be notified of the change.
   */
  set progress(value) {
    this._progress = value;
    this._progressDialog.handleProgress(this);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dialogs/multi-task-progress-modal/task-status.js